import { create } from 'zustand';
import type { UserGroupResourceType } from '../types';

/**
 * Cross-feature dialog store for the Group Security v3 "manage this resource's groups" dialog
 * (ManageResourceGroupsDialog). Group Security spans every content type — folders, screens, assets,
 * playlists, schedules — so a single shared store + one host (GroupSecurityDialogHost, mounted once
 * in AppShell) is cleaner than a per-feature DialogType in every content dialog-store. Any 3-dots
 * menu opens it via `openManageGroups({...})`.
 */
export interface ManageGroupsTarget {
  resourceType: UserGroupResourceType;
  resourceId: string;
  teamId?: string;
  resourceName?: string;
}

interface GroupSecurityDialogState {
  target: ManageGroupsTarget | null;
  openManageGroups: (target: ManageGroupsTarget) => void;
  close: () => void;
}

export const useGroupSecurityDialogStore = create<GroupSecurityDialogState>((set) => ({
  target: null,
  openManageGroups: (target) => set({ target }),
  close: () => set({ target: null }),
}));
